import React, { useState } from 'react'
import { Box, Button, Typography, Alert, Paper, useTheme } from '@mui/material'
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined'
import { ReactComponent as CalendarIcon } from '../../../../../common/icons/calendar_blank_icon.svg'
import { ReactComponent as UserIcon } from '../../../../../common/icons/user_icon.svg'
import { ReactComponent as TagIcon } from '../../../../../common/icons/tag_icon.svg'
import { DatePicker } from '@mui/x-date-pickers/DatePicker'
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider'
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs'
import RocketLaunchOutlinedIcon from '@mui/icons-material/RocketLaunchOutlined'
import dayjs from 'dayjs'
import CampaignPreviewWrapper from './CampaignPreviewWrapper'

import {
  containedBottomButton,
  contentArea,
  alertStyles,
  footerArea,
  outlinedBottomButton,
  fieldValueStyles,
  campaignInfoItemStyles,
  dateSelectStyles,
  campaignPreviewCardStyles,
  campaignTitleStyles,
  fieldLabelStyles
} from './launchCampaignStyles'

export default function CampaignPreviewStep({ onLaunch, onBack }) {
  const theme = useTheme()
  const [customDate, setCustomDate] = useState(dayjs())

  const handleCustomDateChange = newDate => {
    setCustomDate(newDate)
  }

  const handleLaunch = () => {
    const launchData = {
      startDate: customDate.format('YYYY-MM-DD'),
      timeline: 'IMMEDIATELY'
    }
    onLaunch(launchData)
  }

  return (
    <>
      <CampaignPreviewWrapper>
        <Box sx={contentArea}>
          <Paper elevation={0} sx={campaignPreviewCardStyles}>
            <Typography sx={campaignTitleStyles}>Initial Simulation Campaign</Typography>

            <Box sx={campaignInfoItemStyles}>
              <UserIcon />
              <Box>
                <Typography sx={fieldLabelStyles}>Target</Typography>
                <Typography sx={fieldValueStyles}>All employees</Typography>
              </Box>
            </Box>

            <Box sx={campaignInfoItemStyles}>
              <CalendarIcon />
              <Box sx={{ flexGrow: 1 }}>
                <Typography sx={fieldLabelStyles}>Send Date</Typography>
                <Box sx={{ mt: 2 }}>
                  <LocalizationProvider dateAdapter={AdapterDayjs}>
                    <DatePicker
                      format={'DD/MM/YYYY'}
                      slots={{
                        openPickerIcon: CalendarIcon
                      }}
                      disablePast={true}
                      minDate={dayjs()}
                      slotProps={{
                        textField: {
                          size: 'small',
                          sx: dateSelectStyles
                        }
                      }}
                      onChangeRaw={e => e.preventDefault()}
                      shouldDisableDate={date => date.isBefore(dayjs(), 'day')}
                      value={customDate}
                      onChange={handleCustomDateChange}
                    />
                  </LocalizationProvider>
                </Box>
              </Box>
            </Box>

            <Box sx={campaignInfoItemStyles}>
              <TagIcon />
              <Box>
                <Typography sx={fieldLabelStyles}>Template</Typography>
                <Typography sx={fieldValueStyles}>AI-Generated Email</Typography>
              </Box>
            </Box>
          </Paper>
        </Box>
        <Alert
          iconMapping={{
            success: <InfoOutlinedIcon fontSize='inherit' />
          }}
          severity='success'
          sx={alertStyles(theme, 'success')}
        >
          We will send phishing simulation email to all employees.
        </Alert>
      </CampaignPreviewWrapper>

      <Box sx={footerArea(theme)}>
        <Button variant='outlined' onClick={onBack} sx={outlinedBottomButton}>
          Back
        </Button>
        <Button
          variant='contained'
          startIcon={<RocketLaunchOutlinedIcon />}
          onClick={handleLaunch}
          sx={containedBottomButton}
        >
          Launch
        </Button>
      </Box>
    </>
  )
}
